import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import ProjectCard from '../../components/ProjectCard';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import { TiTick } from 'react-icons/ti';
import { IoMdGitNetwork } from 'react-icons/io';
import { otherTexts } from '../../data/services';
import { useVoice } from '../../hooks/useVoice';
import Fade from 'react-reveal/Fade';
import TheMap from '../../components/Map';
import { Helmet } from 'react-helmet';
import ProjectStats from '../../components/ProjectStats';
import Slider from 'react-slick';
import useProjects from '../../hooks/useProjects';
import { AiOutlineArrowRight } from 'react-icons/ai';

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function Projects() {
  const Speak = useVoice();

  const { allProjects, totalCount, projectStats } = useProjects();

  const { capex, opex, pipeline, ipp } = projectStats[0];

  return (
    <div id='contact-us'>
      <Helmet>
        <title>Projects | Solaric</title>
        <link
          async
          rel='stylesheet'
          type='text/css'
          charset='UTF-8'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
        />
        <link
          async
          rel='stylesheet'
          type='text/css'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
        />
        <link
          rel='stylesheet'
          href='https://unpkg.com/leaflet@1.7.1/dist/leaflet.css'
          integrity='sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=='
          crossorigin=''
        />
      </Helmet>

      <div className='heading-links BgProjects'>
        <Bounce>
          <h1>We are Solaric</h1>
        </Bounce>
        <h6>
          <Link to='/' className='mr-2'>
            Home{' '}
          </Link>
          <span>{'>'}</span> Our Projects
        </h6>
      </div>

      <div className='container-fluid pb-5 serviceMap' id='all'>
        <div className='container pb-2'>
          <div className='d-md-flex justify-content-center align-items-center pb-5'>
            <div className='col-md-6 main-services mr-2'>
              <h4 className='title'></h4>
              <Bounce top>
                <h2 className='subtitle pt-md-5'>
                  <span>PROJECT PIPELINE</span>
                </h2>
              </Bounce>
              <Fade>
                <p>
                  {otherTexts.facts} <Speak text={otherTexts.facts} />
                </p>
              </Fade>
              <div className='bars'>
                <ProjectStats title='Total Installations' years={[50, 60, 300, 500, 200]} count={pipeline} />
                <ProjectStats title='Rooftop (CAPEX)' years={[30, 40, 60, 70, 80]} count={capex} />
                <ProjectStats title='Rooftop (OPEX)' years={[20, 50, 40, 80, 120]} count={opex} />
                <ProjectStats title='Ground Mounted (IPP)' years={[0, 50, 200, 350, 200]} count={ipp} />
              </div>
            </div>
            <div className='col-md-6 mapContainer'>
              <div className='locationTitle'>Track our projects</div>
              <TheMap projects={allProjects} />
            </div>
          </div>
        </div>
      </div>

      {/* Projects starts here */}
      <div className='container' style={{ paddingBottom: '3rem' }}>
        <div className='row header-title text-center' id='completed'>
          <div className='col-md-8 col-lg-6 mx-auto'>
            <Bounce left>
              <h2>
                <span>Explore the Projects</span>
              </h2>
            </Bounce>
            <h4>Reach out for a new project or just say hello</h4>
          </div>
        </div>

        <div className='project-page-title'>
          <TiTick className='icon' />
          <div id='ongoing'></div>
          <div className='h6'>Completed Projects</div>
        </div>

        <div className='row mx-auto mt-4 mb-5 projectContainer'>
          <Slider {...settings}>
            {allProjects.map((project) => {
              if (project?.type === 'completed') return <ProjectCard key={project.id} project={project} />;
            })}
          </Slider>
          <div className='mt-5 d-flex justify-content-center'>
            <Link to='/projects/completed' className='more-container'>
              See all
              <AiOutlineArrowRight className='icon' />
            </Link>
          </div>
        </div>

        <div className='project-page-title'>
          <div className='h6'>Ongoing Projects</div>
        </div>
        <div className='row mx-auto mt-4 mb-5 projectContainer' id='ongoing'>
          <Slider {...settings}>
            {allProjects.map((project) => {
              if (project?.type === 'ongoing') return <ProjectCard key={project.id} project={project} />;
            })}
          </Slider>
          <div className='mt-5 d-flex justify-content-center'>
            <Link to='/projects/ongoing' className='more-container'>
              See all
              <AiOutlineArrowRight className='icon' />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
